import {
  IDateInputElement,
  isDateComparisonSchema,
} from "@graffer-inc/form-schema";
import { AllowedTermValidationEditor } from "../validation/allowed-term/allowed-term-validation-editor";

type Props = {
  element: IDateInputElement;
};

export const DateInputValidationEditor: React.FC<Props> = ({ element }) => {
  const schema = element.validations.find(isDateComparisonSchema);

  return (
    <div>
      <div className="field">
        <label className="label">入力規則設定</label>
      </div>
      <AllowedTermValidationEditor schema={schema} />
    </div>
  );
};
